/* eslint-disable */
import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "../../locale/useTranslation";
import { EditPageHeader } from "../../components/EditPageHeader";
import MediaEpisodeAssetEditForm from "../../modules/MediaLibrary/MediaEpisodeAssetEditForm";
import * as API from '../API/api';
import { ASSETTYPE, ENTITYNAME, LOCALSTORAGE_KEY, LOGEVENT, MODULE, OTTROUTETYPE, PUBLISHING_SOURCE, TOAST_TYPES } from "../constant/constant";
import BossDialog from "../../components/BossDialog";
import { utility } from "../utility/utilityProvider";
import ToastNotification from "../../components/ToastNotification";

export const OttEditForm = (props) => {

  const lang = useTranslation();
  const Company = utility.getValue(LOCALSTORAGE_KEY.COMPANY);

  const [assetEntity, setAssetEntity] = useState({});

  //LANGUAGE CHANGES
  const [languages, _setLanguages] = useState([]);

  const selectedLanguageRef = useRef();
  const [selectedLanguage, _setSelectedLanguage] = useState({});
  const setSelectedLanguage = async (data, load = false) => {
    selectedLanguageRef.current = data;
    _setSelectedLanguage(data);
  }
  const languageRef = useRef();
  const setLanguages = (data) => {
    languageRef.current = data;
    _setLanguages(data);
  }

  const [mediaEpisodePublishings, setMediaEpisodePublishings] = useState([]);
  const [removedMedia, setRemovedMedia] = useState([]);

  useEffect(() => {
    loadcombo()
  }, []);

  const loadcombo = async () => {
    let languageRes = await API.getDataLookup(ENTITYNAME.Language, { sort: { Description: 1 }, query: ['Archive', '=', false] });
    setLanguages(languageRes.data);
    setSelectedLanguage(Company.Language);
  }

  const setDataEntity = (entity) => {
    setAssetEntity(entity)
  }

  //function to check the validation in form

  async function isValid() {
    let assetTypeID = (typeof assetEntity?.OttAssetTypeSID === 'object' && assetEntity?.OttAssetTypeSID?.ID) ? assetEntity?.OttAssetTypeSID?.ID : assetEntity?.OttAssetTypeSID;
    let routeTypeObj = assetEntity?.routeType;
    let routeTypeID = (typeof routeTypeObj === 'object' && routeTypeObj?.ID) ? routeTypeObj?.ID : routeTypeObj;

    const hasValidTitle = Array.isArray(assetEntity?.Title)
      && assetEntity?.Title?.length > 0
      && assetEntity?.Title.some(t => t.value?.trim());

    const hasPosters = Array.isArray(assetEntity?.Posters)
      && assetEntity?.Posters?.length > 0
      && assetEntity?.Posters.some(p => Array.isArray(p.value) && p.value.length > 0);

    const hasVideos = Array.isArray(assetEntity?.Videos)
      && assetEntity?.Videos?.length > 0
      && assetEntity?.Videos.some(p => Array.isArray(p.value) && p.value.length > 0);

    if (assetTypeID !== ASSETTYPE.Text) {
      if (assetTypeID === ASSETTYPE["Media Asset"] && Object.keys(assetEntity?.Source).length === 0) {
        ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_attach_media_first });
        return false;
      }

      if (!assetEntity.VodTypes || Object.keys(assetEntity?.VodTypes).length === 0) {
        ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_vod_type_validation_error_message });
        return false;
      }

      if (!routeTypeID || routeTypeID === "") {
        ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_route_type_error_message });
        return false;
      }

      if (assetTypeID !== ASSETTYPE.Music && assetTypeID !== ASSETTYPE["Media Asset"] && !hasValidTitle) {
        ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_enter_title_error_message });
        return false;
      }

      if (assetTypeID === ASSETTYPE.Web && Object.keys(assetEntity.WebAssets).length === 0) {
        ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_web_assets_error_message });
        return false;
      }

      if ((routeTypeID === OTTROUTETYPE.Page) && (!assetEntity.page_id || assetEntity.page_id === "")) {
        ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_page });
        return false;
      }

      if ((routeTypeID === OTTROUTETYPE.PiPage) && Object.keys(assetEntity.Source).length === 0) {
        ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_asset_type_to_media_asset_error_message });
        return false;
      }

      if (assetTypeID !== ASSETTYPE.Music) {
        if (routeTypeID !== OTTROUTETYPE.Page && !hasVideos) {
          ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_attach_atleast_one_video_error_message });
          return false;
        }
      }

      let videosArr = utility.getItemDisplayValueByLang(assetEntity.Videos, Company.Language)
      if (routeTypeID == OTTROUTETYPE.Deeplink && !videosArr.some(x => x.OttVideoType?.Description === "Deeplink")) {
        ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_add_deeplink_in_video_list_error_message });
        return false;
      }

      if (!hasPosters) {
        ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_attach_atleast_one_poster_error_message });
        return false;
      }

      if (routeTypeID === OTTROUTETYPE.MusicPlaylist && (!assetEntity.Playlist || assetEntity.Playlist === "")) {
        ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_playlist });
        return false;
      }

      if (routeTypeID === OTTROUTETYPE.MusicPlayer) {
        const hasMP3 = assetEntity.Videos?.some(v =>
          Array.isArray(v.value) &&
          v.value.some(y => y?.OttVideoType?.Description === "MP3")
        );

        if (!hasMP3) {
          ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_add_mp3_video_for_music });
          return false;
        }
      }

      if (Object.keys(assetEntity.Source).length > 0) {
        let checkQuery = ['Source._id', '=', assetEntity.Source._id];
        if (props.item._id !== undefined) {
          checkQuery = [['Source._id', '=', assetEntity.Source._id], ['_id', '!=', props.item._id]];
        }

        const attachedInAsset = await API.getData(props.entityname, { query: checkQuery });
        if (attachedInAsset.data.length > 0) {
          ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.media_is_already_attached_with_another_asset_error_message });
          return false;
        }
      }
    } else {
      if (assetEntity.Title == "" || assetEntity.Title == undefined) {
        ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_enter_title_error_message });
        return false;
      }
    }

    return true;
  }

  const onSubmit = async () => {

    if (await isValid()) {

      let saveData = {
        SID: assetEntity.SID,
       OttAssetTypeSID: (typeof assetEntity.OttAssetTypeSID === 'object' && assetEntity?.OttAssetTypeSID?.ID) ? assetEntity?.OttAssetTypeSID?.ID : assetEntity?.OttAssetTypeSID,
        StartDate: new Date(assetEntity.StartDate).getTime(),
        EndDate: new Date(assetEntity.EndDate).getTime(),
        Title: assetEntity.Title,
        Description: assetEntity.Description,
        Archive: assetEntity.Archive ?? false,
        Source: {},
        page_id: (typeof assetEntity.page_id === 'object' && assetEntity?.page_id?._id) ? assetEntity?.page_id?._id : assetEntity?.page_id,
        routeType: (typeof assetEntity.routeType === 'object' && assetEntity?.routeType?.ID) ? assetEntity?.routeType?.ID : assetEntity?.routeType,
        RentalRetailPrice: assetEntity.VodTypes.Name == 'TVOD' ? assetEntity.RentalRetailPrice : 0,
        RentalWholesalePrice: assetEntity.VodTypes.Name == 'TVOD' ? assetEntity.RentalWholesalePrice : 0,
        accessLevel: assetEntity.accessLevel?._id,
        IsOttAsset: assetEntity.IsOttAsset,
        IsOttReady: assetEntity.IsOttReady,
        VodTypes: assetEntity.VodTypes && Object.keys(assetEntity.VodTypes).length > 0 ? {
          _id: assetEntity.VodTypes._id,
          SID: assetEntity.VodTypes.SID,
          Name: assetEntity.VodTypes.Name
        } : {},
        Provider: assetEntity?.Provider ? assetEntity?.Provider?._id : "",
        UploadVideo: assetEntity.UploadVideo,
        VideoStatus: assetEntity.VideoStatus,
        Videos: assetEntity.Videos,
        Posters: assetEntity.Posters,
        WebAssets: assetEntity?.WebAssets ? assetEntity?.WebAssets?._id : null,
        Segments: (assetEntity?.Segments && assetEntity?.Segments?.length > 0) ? assetEntity?.Segments?.map((x) => {
          return {
            _id: x?._id,
            Description: x?.Description
          }
        }) : [],
        Playlist: typeof assetEntity.Playlist === 'object' ? { _id: assetEntity?.Playlist?._id, Description: assetEntity?.Playlist?.Description } : assetEntity?.Playlist,
        SubTitles: assetEntity?.SubTitles && assetEntity?.SubTitles.length > 0 ? assetEntity?.SubTitles : [],
        thumbnailUrl: assetEntity?.thumbnailUrl
      }

      if (assetEntity._id && assetEntity._id.length != 0) {
        saveData._id = assetEntity._id
      }

      if (assetEntity.OttAssetTypeSID == ASSETTYPE["Media Asset"]) {
        saveData.Title = saveData.Description
      }

      if (saveData.OttAssetTypeSID == ASSETTYPE["Media Asset"]) {
        saveData.Source = {
          _id: assetEntity.Source._id,
          SID: assetEntity.Source.SID,
          Title: assetEntity.Source.Title,
          MediaCategory: assetEntity.Source.MediaCategory,
          entityName: assetEntity.Source.entityName
        }
        let mediaData = await API.getData(assetEntity.Source.entityName, { query: ['_id', '=', assetEntity.Source._id] });
        let saveMediaItem = {
          ...mediaData.data[0],
          IsOttAsset: true
        }
        console.log(assetEntity.Source.entityName);
        let saveRes = await API.saveData(assetEntity.Source.entityName, saveMediaItem);
        console.log(saveRes);

        //PUBLISHING TAB SAVE OR CREATING DEAFAULT rights
        await API.createAndUpdateDealRights(mediaEpisodePublishings.filter(x => x.PublishingSource == PUBLISHING_SOURCE.MediaEpisode), mediaData?.data?.[0]?._id);

      }

      if (saveData?.OttAssetTypeSID == ASSETTYPE.Music) {
        saveData.Source = assetEntity?.Source
      }

      props.onSubmit({}, saveData);

    } else {
      console.log('Not saved');
    }
  };

  return (
    <>
      <BossDialog
        title={
          props?.item?.copy || !props?.item?.Title
            ? lang.assets_dialog_header
            : utility.getItemDisplayValueByLang(props?.item?.Title, Company.Language)
        }
        onClose={props.cancelEdit}
        width={"830px"}
        height={"700px"}
      >
        <EditPageHeader
          showTitle={false}
          onSubmit={onSubmit}
          onCancel={props.cancelEdit}
          languages={languages}
          selectedLanguage={selectedLanguage}
          setSelectedLanguage={setSelectedLanguage}
        />
        <MediaEpisodeAssetEditForm
          source={'self'}
          dataItem={props.item}
          setDataEntity={setDataEntity}
          selectedLanguage={selectedLanguage}
          setSelectedLanguage={setSelectedLanguage}
          showPublishingTab={true}

          mediaEpisodePublishings={mediaEpisodePublishings}
          removedMedia={removedMedia}

          setMediaEpisodePublishings={setMediaEpisodePublishings}
          setRemovedMedia={setRemovedMedia}
        />
      </BossDialog>
    </>
  )
};